import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { TechnologyPlatformListComponent } from './technology-platform-list/technology-platform-list.component'

export const technologyPlatformRoutes: Route[] = [
  {
    path: 'technology-platforms',
    component: TechnologyPlatformListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'technology-platforms/:id/edit',
    redirectTo: 'technology-platforms/:id',
    pathMatch: 'full'
  },
  {
    path: 'technology-platforms/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'TechnologyPlatform',
        nameSingular: 'Technology Platform',
        namePlural: 'Technology Platforms',
        path: 'technology-platforms',
        slug: 'taxonomies/technology-platforms',
        title: 'Technology Platforms'
      }),
      permission: 'readTaxonomies'
    }
  }
]
